const visibilityLevel = [
    {id: 1, name: 'Private'},
    {id: 2, name: 'Visible to everyone'},
    {id: 3, name: 'Visible to all registered users'},
    {id: 4, name: 'Visible to followers only'},
]

export default visibilityLevel